import styled from '@emotion/styled'
import { tokens } from '@news-mono/design-tokens'
import {
    breakWords,
    breakpoint,
    calcRem,
    colors,
    fonts,
    metrics,
} from '../../../__styling'
import { CardMedia } from '../../../cards/CardMedia/CardMedia'
import { CardText } from '../../../cards/CardText/CardText'

const playButton = require('./assets/playButton.svg')

export const StyledVideoCard = styled('div')({
    ...breakWords,
    position: 'relative',
    width: '100%',
    height: 'auto',
    cursor: 'pointer',
    padding: calcRem(5, 0),
    marginBottom: 0,
    display: 'flex',
    flexWrap: 'wrap',
    flexGrow: 'initial',
    alignItems: 'flex-start',
    flexDirection: 'column',
    [breakpoint('md')]: {
        marginBottom: calcRem(15),
        height: 'unset',
        flexDirection: 'row',
        alignItems: 'center',
    },
})

export const StyledVideoCardMediaWrapper = styled('div')({
    display: 'flex',
    flex: 1,
    marginRight: calcRem(metrics.sevennews.margins.md),
    width: '100%',
    position: 'relative',
})

export const StyledUpNextCopy = styled('div')({
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    left: 0,
    bottom: 0,
    background: colors.black,
    color: tokens.sevennews.colors.palette.red,
    fontSize: calcRem(12),
    padding: calcRem(6),
    gap: calcRem(4),
})

export const StyledVideoCardMedia = styled(CardMedia)({
    marginBottom: 0,
    width: '100%',

    '& [class*="StyledPlayIcon"], & [class*="StyledMediaIndicator"]': {
        display: 'none',
    },
})

export const StyledVideoCardTextWrapper = styled('div')({
    display: 'block',
    flexWrap: 'wrap',
    flex: 1,
    marginTop: calcRem(5),
    [breakpoint('md')]: {
        marginTop: 0,
    },
})

export const StyledVideoLength = styled('span')({
    position: 'absolute',
    right: calcRem(6),
    bottom: calcRem(6),
    color: colors.white,
    fontSize: calcRem(12),
    fontWeight: 700,
})
export const StyledVideoCardText = styled(CardText)(({ theme }) => ({
    display: 'flex',
    margin: 0,
    '& [class*="Card-Headline"]': {
        fontSize: calcRem(13),
        fontFamily: fonts.sevennews.sansSerif,
        [breakpoint('md')]: {
            fontSize: calcRem(14),
        },
    },
    '& [class*="StyledHeadlineText"]': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        lineClamp: 3,
        color: tokens.sevennews.colors.palette.white,
        '-webkit-line-clamp': '3',
        '-webkit-box-orient': 'vertical',
    },
}))
